import * as React from "react";
import { IconProps } from "./IconProps";

export const IconDeleteBookmark = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = "currentColor", ...props }, forwardedRef) => {
    return (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        ref={forwardedRef}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4 3C4 2.44772 4.44772 2 5 2H19C19.5523 2 20 2.44772 20 3V21C20 21.3565 19.8102 21.686 19.5019 21.8649C19.1936 22.0438 18.8134 22.0451 18.5039 21.8682L12 18.1518L5.49614 21.8682C5.18664 22.0451 4.80639 22.0438 4.49807 21.8649C4.18976 21.686 4 21.3565 4 21V3ZM6 4V19.2768L11.5039 16.1318C11.8113 15.9561 12.1887 15.9561 12.4961 16.1318L18 19.2768V4H6ZM9.17159 7.17156C9.56212 6.78104 10.1953 6.78104 10.5858 7.17156L12 8.58579L13.4142 7.17159C13.8048 6.78106 14.4379 6.78106 14.8284 7.17159C15.219 7.56211 15.219 8.19528 14.8284 8.5858L13.4142 10L14.8284 11.4142C15.219 11.8047 15.219 12.4379 14.8284 12.8284C14.4379 13.2189 13.8048 13.2189 13.4142 12.8284L12 11.4142L10.5858 12.8284C10.1953 13.219 9.56211 13.219 9.17159 12.8284C8.78107 12.4379 8.78107 11.8048 9.17159 11.4142L10.5858 10L9.17159 8.58577C8.78107 8.19525 8.78107 7.56208 9.17159 7.17156Z"
          fill={color}
        />
      </svg>
    );
  },
);
